<template>
    <div id="client-onboarding-wrapper">
        <OnboardingWalkthrough v-if="shouldOpenWalkthrough" />
        <span v-else data-testid="client-onboarding-walkthrough-not-loaded" />
    </div>
</template>

<script setup lang="ts">
    import {computed, defineAsyncComponent, ref} from 'vue';
    import {navbarEventBus} from '@navbar/public-api';
    import {storeToRefs} from 'pinia';
    import {useRoute} from 'vue-router';
    import {useAuth} from '#imports';
    import {useOnboardingStore} from '../stores/onboardingClient.store';

    const route = useRoute();

    const auth = useAuth();
    const {currentIdentityIsClient} = storeToRefs(auth);

    const onboardingStore = useOnboardingStore();
    const {initOnboardingState} = onboardingStore;
    const {isOnboardingVisible, atLeastOneStepVisible} = storeToRefs(onboardingStore);

    await initOnboardingStateIfNeeded();

    async function initOnboardingStateIfNeeded() {
        if (!currentIdentityIsClient.value) {
            return;
        }

        const collapse = /keyword/i.test(route.query.search_mode as string);
        await initOnboardingState(collapse);
    }

    const isMobileNavbarOpened = ref<boolean>();

    navbarEventBus.on('request:navbar-toggle-on-mobile', ({isOpen}) => (isMobileNavbarOpened.value = isOpen));

    const shouldOpenWalkthrough = computed(() => isOnboardingVisible.value && atLeastOneStepVisible.value && !isMobileNavbarOpened.value);

    const OnboardingWalkthrough = defineAsyncComponent(() => import('./OnboardingWalkthrough.vue'));
</script>
